import { render, staticRenderFns } from "./palletList.vue?vue&type=template&id=c3978ffe"
import script from "./palletList.vue?vue&type=script&lang=js"
export * from "./palletList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports